<div class="add-player-container">
    <h2>Agregar jugador a grupo</h2>

    <div class="info">
        Categoria: <strong>{{ category }}</strong>
    </div>
    <div class="info">
        Grupo: <strong>{{ group }}</strong>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="fill">
            <mat-label>Id del jugador</mat-label>
            <input matInput formControlName="playerId" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit" [disabled]="form.invalid">Agregar</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>
    </form>
</div>